import { Component, ElementRef, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../core/auth.service';
import { Lecture } from '../../lectures/shared/lecture';
import { ObjectObservable } from '../../shared/base/object-observable';
import { UserService } from '../../users/shared/user.service';
import { Lesson } from '../shared/lesson';

@Component({
  selector: 'app-lesson',
  templateUrl: './lesson.component.html',
  styleUrls: ['./lesson.component.scss']
})
export class LessonComponent implements OnInit {
  lessonObservable: Observable<Lesson>;
  lectureObservable: Observable<Lecture>;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.route.data.subscribe((data: { lesson: Observable<Lesson> }) => this.lessonObservable = data.lesson);
    this.route.parent.parent.parent.data.subscribe((data: { lecture: Observable<Lecture> }) => this.lectureObservable = data.lecture);
    // this.userService.update(this.authService.uid, Object.assign({}, this.authService.user, {
    //   latestLessonUrl: this.router.url
    // }));
  }

  onEdit() {
    this.router.navigate(['edit'], { relativeTo: this.route });
  }

  clicked(event) {
    const selection = window.getSelection();
    const range = document.createRange();
    const code = event.target.closest('code');

    if (code) {
      range.selectNodeContents(code);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('copy');
      this.snackBar.open('클립보드에 소스코드가 복사되었습니다..', '', {
        duration: 2000,
      });
    }
  }
}









// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lessons/lesson/lesson.component.ts